export {
  toggleModal
}

function toggleModal (isOpenModal, componentModal, code = '') {
  return dispatch => {
    dispatch({ code, componentModal, isOpenModal, type: 'TOGGLE_MODAL' })
  }
}
